import React from 'react'

import { CobrandingLogo } from '@frame/ui-components/cobranding-logo'
import { ContactUs } from '@frame/ui-components/contact-us'
import { Footer } from '@frame/ui-components/footer'
import { BaseWidgetHeader } from '@frame/ui-components/widget-header'
import { Body } from '@frame/ui-primitives/body'
import { Button } from '@frame/ui-primitives/button'
import { H2 } from '@frame/ui-primitives/h2'
import { P } from '@frame/ui-primitives/p'

import { useRootContext } from '@frame/lib/context'
import { useStore } from '@frame/lib/stores/useStore'
import { getTextForVerificationType, getVerifierDisplayName } from '@frame/lib/utils/session'
import { DataAttribute } from '@frame/types'

export function Failed() {
  const { events } = useRootContext()
  const { verifierName, verificationType, closeable, tenantPropertyName, verifierType } = useStore((state) => ({
    verifierName: state.session?.originating_party_display_name,
    verificationType: state.session?.verification_type,
    closeable: state.session?.consumer_initiated,
    tenantPropertyName: state.session?.configuration?.cobranding?.tenant_property?.property_name,
    verifierType: state.session?.verifier_type,
  }))

  const incomeOrEmployment = getTextForVerificationType(verificationType)
  const displayName = getVerifierDisplayName(verifierType, verifierName, tenantPropertyName)

  return (
    <>
      <BaseWidgetHeader />
      <Body data-cy={DataAttribute.SCREEN_TERMINAL_FAILED} paddingTopOverride={0} className="p-5">
        <CobrandingLogo />
        <div>
          <H2 className="my-5 text-center">We are having trouble connecting to your account</H2>
          <P className="mb-2">
            Unfortunately, we were unable to verify your {incomeOrEmployment || 'information'} at this time.
          </P>
          <ContactUs />
        </div>
      </Body>
      {closeable ? (
        <Footer
          buttons={{
            primary: (
              <Button
                data-cy={DataAttribute.BTN_CONTINUE_TO_VERIFIER}
                applyCobranding
                onClick={() => {
                  events.emit('close')
                }}
              >
                Continue to {displayName}
              </Button>
            ),
          }}
        />
      ) : null}
    </>
  )
}
